import http from './default.js'

export default class ClientsService {
  static async getAllClients() {
    const clientsLocations = `${process.env.REACT_APP_CLIENTS_LOCATIONS}/v1/all-clients`

    const response = await http.get(clientsLocations)

    const processClients = response.map(currClient => ({
      ...currClient,
      label: `${currClient.client_id} - ${currClient.client_name}`,
      value: `${currClient.client_id}`
    }))

    return processClients
  }
  
  static async getLocationsByClient(client) {
    const allLocations = `${process.env.REACT_APP_CLIENTS_LOCATIONS}/v1/client/${client}/locations/all`

    const response = await http.get(allLocations)
    return response
  }

  static async getClient(client_id) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/clients/${client_id}`
    const response = await http.get(clientConfig)
    return response
  }

  static async createClient(trClientId, clientData) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/clients/${trClientId}`
    const response = await http.post(clientConfig, clientData)
    return response
  }

  static async updateClient(trClientId, clientData) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/clients/${trClientId}`
    const response = await http.patch(clientConfig, clientData)
    return response
  }

  static async getClientEditHistory(trClientId, pageSize, pageNumber) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/editHistory?clientId=${trClientId}&size=${pageSize}&page=${pageNumber}`
    const response = await http.get(clientConfig)
    return response
  }

  static async getPackageAndFeatures() {
    const packageReq = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/clientPackagesTemplate`
    const response = await http.get(packageReq)
    return response
  }

  static async getTRClient(client_id) {
    const clientUrl = `${process.env.REACT_APP_ONBOARDING_SERVICE}/INTERNAL/clients/${client_id}`
    const response = await http.get(clientUrl)
    return response
  }

  static async getClientMigrationStatus(trClientId, pageSize, pageNumber) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/migration/status/${trClientId}?size=${pageSize}&page=${pageNumber}`
    const response = await http.get(clientConfig)
    return response
  }

  static async updateViewMigratedDataFlag(trClientId, viewMigratedData) {
    const clientConfig = `${process.env.REACT_APP_TR_TRACKER_INTEGRATION_CONFIG}/api/v1/clients/view-migrated-data`
    const response = await http.patch(clientConfig, [{trClientId: trClientId, viewMigratedData: viewMigratedData}])
    
    // Check if there are any errors in the response
    if (response.errorCount > 0) {
      const errorMessage = response.errors.map(err => err.error).join(', ')
      throw {
        response: {
          data: {
            responseCode: 'UPDATE FAILED',
            responseMessage: errorMessage
          }
        }
      }
    }
    
    return response
  }
}
